const serialize = function(obj, prefix) {

    var str = [], p;

    for (p in obj) {

        if (Object.prototype.hasOwnProperty.call(obj, p)) {

            var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];

            str.push((v !== null && typeof v === "object")
                ? serialize(v, k)
                : encodeURIComponent(k) + "=" + encodeURIComponent(v == null ? '' : v));
        }
    }

    return str.join("&");
}

export default {
    serialize
}